import React, { useState } from 'react';
import './CallNotification.css';
import { FaPhone, FaExpandAlt, FaChevronDown, FaVoicemail, FaBell, FaRobot, FaBroadcastTower, FaWindowMinimize, FaWindowMaximize } from 'react-icons/fa';

const CallNotification = ({ call, onAnswer, onViewDetails, onRemind, onDismiss, onSendToAIAgent }) => {
  const [isOtherMenuOpen, setIsOtherMenuOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  if (!call) {
    return null;
  }

  const getPriorityStyles = (priority) => {
    const styles = {
      notification: {
        backgroundColor: '#fff',
        border: '2px solid'
      },
      summary: {
        border: '1px solid'
      },
      count: {}
    };

    switch (priority) {
      case 'high':
        styles.notification.borderColor = '#e53e3e';
        styles.summary.backgroundColor = '#fee2e2';
        styles.summary.borderColor = '#fca5a5';
        styles.summary.color = '#b91c1c';
        styles.count.backgroundColor = '#b91c1c';
        styles.count.color = '#fff';
        break;
      case 'medium':
        styles.notification.borderColor = '#f6ad55';
        styles.summary.backgroundColor = '#fef3c7';
        styles.summary.borderColor = '#fde68a';
        styles.summary.color = '#b45309';
        styles.count.backgroundColor = '#fde68a';
        styles.count.color = '#b45309';
        break;
      case 'low':
        styles.notification.borderColor = '#3b82f6';
        styles.summary.backgroundColor = '#e0eaff';
        styles.summary.borderColor = '#bfdbfe';
        styles.summary.color = '#3b82f6';
        styles.count.backgroundColor = '#3b82f6';
        styles.count.color = '#fff';
        break;
      default:
        styles.notification.borderColor = '#ccc';
        break;
    }
    return styles;
  };

  const priorityStyles = getPriorityStyles(call.priority);

  const priorityMessages = {
    high: `${call.priorityItems} high priority items`,
    medium: `${call.priorityItems} medium priority items`,
    low: `${call.priorityItems} low priority item`,
  };

  const toggleOtherMenu = (e) => {
    e.stopPropagation();
    setIsOtherMenuOpen(!isOtherMenuOpen);
  };

  const toggleMinimize = (e) => {
    e.stopPropagation();
    setIsMinimized(!isMinimized);
  };

  return (
    <div
      className={`call-notification ${isMinimized ? 'minimized' : ''}`}
      style={priorityStyles.notification}
      onClick={isMinimized ? toggleMinimize : undefined}
    >
      <div className="call-notification-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span className="status-dot"></span>
          <FaPhone /> Incoming Call
        </div>
        <button className="minimize-btn" onClick={toggleMinimize}>
          {isMinimized ? <FaWindowMaximize /> : <FaWindowMinimize />}
        </button>
      </div>
      {!isMinimized && (
        <>
          <div className="caller-info-summary">
            <div className="caller-avatar">{call.initials}</div>
            <div className="caller-details-summary">
              <p className="caller-name">{call.name}</p>
              <p className="caller-title">{call.title}</p>
              <p className="caller-phone"><FaPhone /> {call.phone}</p>
            </div>
          </div>
          <div className="priority-summary" style={priorityStyles.summary}>
            <span className="priority-count" style={priorityStyles.count}>{call.priorityItems}</span>
            {priorityMessages[call.priority]}
          </div>
          <div className="action-buttons">
            <button className="btn-answer" onClick={onAnswer}><FaPhone /> Answer</button>
            <button className="btn-details" onClick={onViewDetails}><FaExpandAlt /> View Full Details</button>
            <div className="other-menu-container">
              <button className="btn-other" onClick={toggleOtherMenu}>Other <FaChevronDown /></button>
              {isOtherMenuOpen && (
                <div className="other-menu" onClick={(e) => e.stopPropagation()}>
                  <button><FaVoicemail /> Send to Voicemail</button>
                  <button onClick={onRemind}><FaBell /> Remind Me to Call Later</button>
                  <button onClick={onSendToAIAgent}><FaRobot /> Send to AI Agent</button>
                  <button><FaBroadcastTower /> Provide Caller With Live Updates</button>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CallNotification;